import LegalPageLayout from './LegalPageLayout';
import {
  PRIVACY_DOCUMENT_TITLE,
  PRIVACY_EFFECTIVE_DATE,
  PRIVACY_LAST_UPDATED,
  PRIVACY_SUBTITLE,
  PrivacyPolicyContent,
} from './content/privacyPolicyContent';

const PrivacyPolicyPage = () => (
  <LegalPageLayout
    title={PRIVACY_DOCUMENT_TITLE}
    subtitle={PRIVACY_SUBTITLE}
    effectiveDate={PRIVACY_EFFECTIVE_DATE}
    lastUpdated={PRIVACY_LAST_UPDATED}
  >
    <PrivacyPolicyContent />
  </LegalPageLayout>
);

export default PrivacyPolicyPage;
